import { Component } from '@angular/core';
import { NavigationService } from './services/navigation.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'saesa-rmcapFront';
  recargar: number = 0;
  constructor(
    private navigationService: NavigationService)
    {

    }
  ngOnInit() {

  }
  getLoginState(): boolean {
    if(localStorage.getItem('login')) return true
    else false
  }
  actualizarNavBar(input: number){
    
    if (typeof(input) == "number"){
      
      this.recargar = input;
    }
  }
}
